var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSterne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 432 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3{stroke-width:0px;}.cls-4{clip-path:url(#clippath-1);}.cls-5{clip-path:url(#clippath-4);}.cls-6{clip-path:url(#clippath-3);}.cls-7{clip-path:url(#clippath-2);}.cls-3{fill:#ffc400;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.64,
    y: 13.34,
    width: 70.52,
    height: 67.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.6,
    y: 13.34,
    width: 70.52,
    height: 67.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 181.57,
    y: 13.34,
    width: 70.52,
    height: 67.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 268.52,
    y: 13.34,
    width: 70.52,
    height: 67.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 355.48,
    y: 13.34,
    width: 70.52,
    height: 67.74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    className: "cls-3",
    d: "M65.42,55.86c.17-.15.33-.32.49-.48,3.45-3.37,6.93-6.7,10.34-10.11,1.78-1.67,2.39-4.24,1.55-6.53-.63-2.31-2.57-4.02-4.94-4.36-4.62-.76-9.24-1.47-13.88-2.02-1.85-.04-3.5-1.19-4.18-2.91-1.9-4.18-4-8.23-6.03-12.33-1-2.31-3.27-3.79-5.79-3.77-2.59-.13-4.98,1.36-6.02,3.73-2.23,4.49-4.45,8.98-6.65,13.49-.34.82-1.09,1.4-1.97,1.52-4.94.71-9.87,1.45-14.83,2.16-2.72.23-5,2.15-5.69,4.78-.17,1.01-.21,2.04-.11,3.06.45,1.54,1.33,2.93,2.54,3.99,3.42,3.28,6.77,6.6,10.17,9.89.69.6,1,1.52.83,2.41-.78,4.47-1.54,8.94-2.3,13.41-.33,1.24-.43,2.53-.3,3.81.6,3.55,3.96,5.94,7.51,5.34.75-.13,1.48-.38,2.14-.76,4.34-2.28,8.69-4.56,13.01-6.86.95-.58,2.15-.58,3.11,0,4.38,2.34,8.78,4.66,13.2,6.94,3.18,1.67,7.11.44,8.77-2.74.67-1.29.9-2.76.63-4.19-.82-4.9-1.66-9.8-2.52-14.7-.26-1.03.1-2.11.92-2.78"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_32-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8-2",
    className: "cls-3",
    d: "M152.38,55.86c.17-.15.33-.32.49-.48,3.45-3.37,6.93-6.7,10.34-10.11,1.78-1.67,2.39-4.24,1.55-6.53-.63-2.31-2.57-4.02-4.94-4.36-4.62-.76-9.24-1.47-13.88-2.02-1.85-.04-3.5-1.19-4.18-2.91-1.9-4.18-4-8.23-6.03-12.33-1-2.31-3.27-3.79-5.79-3.77-2.59-.13-4.98,1.36-6.02,3.73-2.23,4.49-4.45,8.98-6.65,13.49-.34.82-1.09,1.4-1.97,1.52-4.94.71-9.87,1.45-14.83,2.16-2.72.23-5,2.15-5.69,4.78-.17,1.01-.21,2.04-.11,3.06.45,1.54,1.33,2.93,2.54,3.99,3.42,3.28,6.77,6.6,10.17,9.89.69.6,1,1.52.83,2.41-.78,4.47-1.54,8.94-2.3,13.41-.33,1.24-.43,2.53-.3,3.81.6,3.55,3.96,5.94,7.51,5.34.75-.13,1.48-.38,2.14-.76,4.34-2.28,8.69-4.56,13.01-6.86.95-.58,2.15-.58,3.11,0,4.38,2.34,8.78,4.66,13.2,6.94,3.18,1.67,7.11.44,8.77-2.74.67-1.29.9-2.76.63-4.19-.82-4.9-1.66-9.8-2.52-14.7-.26-1.03.1-2.11.92-2.78"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_32-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8-3",
    className: "cls-3",
    d: "M239.34,55.86c.17-.15.33-.32.49-.48,3.45-3.37,6.93-6.7,10.34-10.11,1.78-1.67,2.39-4.24,1.55-6.53-.63-2.31-2.57-4.02-4.94-4.36-4.62-.76-9.24-1.47-13.88-2.02-1.85-.04-3.5-1.19-4.18-2.91-1.9-4.18-4-8.23-6.03-12.33-1-2.31-3.27-3.79-5.79-3.77-2.59-.13-4.98,1.36-6.02,3.73-2.23,4.49-4.45,8.98-6.65,13.49-.34.82-1.09,1.4-1.97,1.52-4.94.71-9.87,1.45-14.83,2.16-2.72.23-5,2.15-5.69,4.78-.17,1.01-.21,2.04-.11,3.06.45,1.54,1.33,2.93,2.54,3.99,3.42,3.28,6.77,6.6,10.17,9.89.69.6,1,1.52.83,2.41-.78,4.47-1.54,8.94-2.3,13.41-.33,1.24-.43,2.53-.3,3.81.6,3.55,3.96,5.94,7.51,5.34.75-.13,1.48-.38,2.14-.76,4.34-2.28,8.69-4.56,13.01-6.86.95-.58,2.15-.58,3.11,0,4.38,2.34,8.78,4.66,13.2,6.94,3.18,1.67,7.11.44,8.77-2.74.67-1.29.9-2.76.63-4.19-.82-4.9-1.66-9.8-2.52-14.7-.26-1.03.1-2.11.92-2.78"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_32-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8-4",
    className: "cls-3",
    d: "M326.3,55.86c.17-.15.33-.32.49-.48,3.45-3.37,6.93-6.7,10.34-10.11,1.78-1.67,2.39-4.24,1.55-6.53-.63-2.31-2.57-4.02-4.94-4.36-4.62-.76-9.24-1.47-13.88-2.02-1.85-.04-3.5-1.19-4.18-2.91-1.9-4.18-4-8.23-6.03-12.33-1-2.31-3.27-3.79-5.79-3.77-2.59-.13-4.98,1.36-6.02,3.73-2.23,4.49-4.45,8.98-6.65,13.49-.34.82-1.09,1.4-1.97,1.52-4.94.71-9.87,1.45-14.83,2.16-2.72.23-5,2.15-5.69,4.78-.17,1.01-.21,2.04-.11,3.06.45,1.54,1.33,2.93,2.54,3.99,3.42,3.28,6.77,6.6,10.17,9.89.69.6,1,1.52.83,2.41-.78,4.47-1.54,8.94-2.3,13.41-.33,1.24-.43,2.53-.3,3.81.6,3.55,3.96,5.94,7.51,5.34.75-.13,1.48-.38,2.14-.76,4.34-2.28,8.69-4.56,13.01-6.86.95-.58,2.15-.58,3.11,0,4.38,2.34,8.78,4.66,13.2,6.94,3.18,1.67,7.11.44,8.77-2.74.67-1.29.9-2.76.63-4.19-.82-4.9-1.66-9.8-2.52-14.7-.26-1.03.1-2.11.92-2.78"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_32-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8-5",
    className: "cls-3",
    d: "M413.26,55.86c.17-.15.33-.32.49-.48,3.45-3.37,6.93-6.7,10.34-10.11,1.78-1.67,2.39-4.24,1.55-6.53-.63-2.31-2.57-4.02-4.94-4.36-4.62-.76-9.24-1.47-13.88-2.02-1.85-.04-3.5-1.19-4.18-2.91-1.9-4.18-4-8.23-6.03-12.33-1-2.31-3.27-3.79-5.79-3.77-2.59-.13-4.98,1.36-6.02,3.73-2.23,4.49-4.45,8.98-6.65,13.49-.34.82-1.09,1.4-1.97,1.52-4.94.71-9.87,1.45-14.83,2.16-2.72.23-5,2.15-5.69,4.78-.17,1.01-.21,2.04-.11,3.06.45,1.54,1.33,2.93,2.54,3.99,3.42,3.28,6.77,6.6,10.17,9.89.69.6,1,1.52.83,2.41-.78,4.47-1.54,8.94-2.3,13.41-.33,1.24-.43,2.53-.3,3.81.6,3.55,3.96,5.94,7.51,5.34.75-.13,1.48-.38,2.14-.76,4.34-2.28,8.69-4.56,13.01-6.86.95-.58,2.15-.58,3.11,0,4.38,2.34,8.78,4.66,13.2,6.94,3.18,1.67,7.11.44,8.77-2.74.67-1.29.9-2.76.63-4.19-.82-4.9-1.66-9.8-2.52-14.7-.26-1.03.1-2.11.92-2.78"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterne);
export default __webpack_public_path__ + "static/media/Sterne.4b6dbc8c7997d2666fb1d32513217efe.svg";
export { ForwardRef as ReactComponent };